import React from "react";
import styles from "./CloseButton.module.scss";
import { ReactComponent as CloseIcon } from "../../assets/logos/closeIcon.svg";
import Button from "../Button";
const CloseButton = (props) => {
  return (
    <Button
        variant="link"
        size="small"
        borderRadius="round"
        className={`${styles.closeBtn} ${props.className}`}
        onClick={props.onClick}
        data-testid={props["data-testid"]}
        {...props}
      >
        <CloseIcon />
      </Button>
  );
};

export default CloseButton;